import { Injector } from '@angular/core';
import { Farris, FormElementRegistry, FrameContext } from '@farris/devkit';

export class ToolbarPipe {
  constructor(protected injector: Injector, protected frameContext: FrameContext, protected formElementRegistry: FormElementRegistry) { }

  protected process(config: any, type: Farris.FormRule.RuleType) {
    Object.keys(config).forEach((toolbarItemId: string) => {
      const toolbarItem = this.formElementRegistry.getElementById(toolbarItemId);
      if (toolbarItem && toolbarItem.rules && toolbarItem.rules.length > 0) {
        const elementRule = toolbarItem.rules.find((rule: Farris.FormRule.IFormRule) => rule.type === type);
        if (elementRule && elementRule.dynamic) {
          const value = this.eval(`return ${elementRule.rule}`, { viewModel: this.frameContext.viewModel, context: this.frameContext }).apply(this.frameContext.frameComponent);
          config[toolbarItemId] = value;
        }
      }
    });
    return config;
  }
  private eval(expr: string, context: any, args?: any) {
    let signature = '';
    if (typeof args !== 'undefined') {
      if (Array.isArray(args)) {
        signature = args.join(',');
      } else {
        signature = Object.keys(args).join(',');
      }
    }
    const scopeNames = Object.getOwnPropertyNames(context);
    const scopeVariable = `__scope__${new Date().valueOf()}`;
    return new Function(scopeVariable, `
      ${scopeNames.map((key: string) => `var ${key} = ${scopeVariable}['${key}'];`).join('\r\n')}
      return function anonymous(${signature}) {
        try{ \n${expr}\n }catch(e){console.error(e);}
      };`)(context);
  }
}
